import { ScorecardHistoryTable } from './ScorecardHistoryTable';
import { SCORECARDS_DATA_ATTR, type ScorecardHistoryRow } from './styles';

// Interweave `transform` that swaps the stored scorecard-history table for
// the React component, so the Activity column renders with a real Kula
// tooltip in browser contexts.
export const hydrateScorecardTable = (node: HTMLElement) => {
  const payload = node.getAttribute?.(SCORECARDS_DATA_ATTR);
  if (!payload) return undefined;
  try {
    const scorecards = JSON.parse(
      decodeURIComponent(payload)
    ) as ScorecardHistoryRow[];
    return <ScorecardHistoryTable scorecards={scorecards} />;
  } catch {
    return undefined;
  }
};
